import uriTools from './uri-tools'
import {escape} from 'underscore'

//facebook php sdk integration (inbox/social library) for admin users
class InboxSocialIntegration {
    constructor(socialLoginBtnClassName) {
        this.socialLoginBtnClassName = socialLoginBtnClassName;
        this.queryParams = {};
    }

    //click event for link which adds additional query params on click (for redirect hints and passing domain name)
    registerLoginClickHandler() {

        var socialLoginButtons = document.getElementsByClassName(this.socialLoginBtnClassName);
        for (let i = 0; i < socialLoginButtons.length; i++) {
            socialLoginButtons[i].onclick = (e) => {
                e.preventDefault();
                e.stopImmediatePropagation();

                //override successUrl query param if link has successurl data attribute
                if (socialLoginButtons[i].dataset.successurl && !this.queryParams['successUrl']) {
                    this.addCustomQueryParam('successUrl', socialLoginButtons[i].dataset.successurl);
                }

                let username = document.getElementById('username')
                    ? document.getElementById('username').value
                    : null;
                if (username) {
                    this.addCustomQueryParam('username', username);
                }

                let domainName = document.getElementById('domain')
                    ? document.getElementById('domain').value
                    : null;
                if (domainName) {
                    this.addCustomQueryParam('domainName', domainName);
                }

                let newLink = socialLoginButtons[i].getAttribute('href');

                if (Object.keys(this.queryParams).length > 0) {
                    let queryParamsAsString = '?' + uriTools.serializeObjToQueryString(this.queryParams);
                    //for personal signup we double encode because of login
                    if (username) {
                        queryParamsAsString = encodeURIComponent(encodeURIComponent(queryParamsAsString));
                    }
                    newLink = newLink + queryParamsAsString;
                }

                window.location = newLink;
            }
        }
    }

    //adder method to add custom query params which we will pass to social login
    addCustomQueryParam(paramName, value) {
        this.queryParams[paramName] = value;
    }

    registerRedirectQueryDataHandler() {
        document.addEventListener('DOMContentLoaded', () => {
            var queryData = uriTools.deserializeQueryStringToObject();

            //in business signup
            if (queryData['domainName']) {
                const domainName = escape(queryData['domainName']);
                //todo copy pasted- move to function- maybe also revalidate?
                Array.prototype.forEach.call(document.getElementsByClassName('current_domain_placeholder'), (el) => {
                    el.innerHTML = domainName;
                });
                document.getElementById('domain').value = domainName;
            }

            //in personal signup
            if (queryData['username']) {
                document.getElementById('username').value = queryData['username'];
            }
            //in personal signup
            if (!queryData['username'] && queryData['email'] && document.getElementById('username')) {
                let email = queryData['email'];
                document.getElementById('username').value = email.substring(0, email.lastIndexOf("@"));
            }
        });
    }
}

export default InboxSocialIntegration;
